// customers-messages translations (Spanish catalog).
window.PlummeI18n.register('es', {
  'cus.row.noOpenAlerts': 'Sin avisos abiertos',
  'cus.row.openPage': 'Abrir página',
  'cus.row.openTasks': 'Tareas abiertas',
  'cus.row.noOpenTasks': 'Sin tareas abiertas',
  'cus.row.openDeviations': 'Desviaciones abiertas',
  'cus.row.waitingForClient': 'Esperando al cliente',
  'cus.row.upcomingDeadlines': 'Próximos plazos',
  'cus.row.noNearDeadlines': 'Sin plazos cercanos',
  'cus.row.lastActivity': 'Última actividad',
  'cus.row.savedInAccounts': 'guardó en la contabilidad',
  'cus.row.noActivity': 'Sin actividad registrada',
  'cus.row.shortcuts': 'Accesos directos',
  'cus.row.openTheClient': 'Abrir el cliente',
  'cus.row.aiAccountant': 'Contable IA',
  'cus.row.disciplines': 'Áreas especializadas',
  'cus.row.openChatWith': 'Abrir chat con {name} – {status}',
  'cus.row.hideDetailsFor': 'Ocultar detalles de {name}',
  'cus.row.showDetailsFor': 'Mostrar detalles de {name}',
  'cus.row.orgNumber': 'Org. {org}',
  'cus.row.noOrgNumber': 'Sin n.º de organización',
  'cus.row.noResponsible': 'Sin responsable',
  'cus.row.chatWith': 'Chat con {name}',
  'cus.row.chat': 'Chat',
  'cus.row.openClient': 'Abrir cliente',
  'cus.row.collapse': 'Ocultar {name}',
  'cus.row.showMoreAbout': 'Mostrar más sobre {name}',
  'cus.merge.headline': '¿Has creado el mismo cliente dos veces?',
  'cus.merge.help': 'Selecciona el duplicado. Las facturas se mueven al cliente que se conserva y el otro cliente se elimina.',
  'cus.merge.whichSame': '¿Qué cliente es el mismo que {name}?',
  'cus.merge.selectCustomer': 'Selecciona un cliente...',
  'cus.address.searching': 'Buscando en direcciones oficiales...',
  'cus.chat.loadFailed': 'No se pudo cargar el diálogo con el cliente.',
  'cus.chat.notConnected': 'El diálogo con el cliente no está conectado al backend.',
  'cus.chat.newStarted': 'Nueva conversación iniciada el {date}',
  'cus.chat.newFailed': 'No se pudo iniciar una nueva conversación.',
  'cus.chat.quoteBasisFailed': 'No se pudo guardar la base del presupuesto.',
  'cus.chat.offerCreated': 'Borrador de presupuesto creado para {name}',
  'cus.chat.offerFailed': 'No se pudo crear el presupuesto.',
  'cus.chat.savedInDialog': 'Mensaje guardado en el diálogo',
  'cus.chat.customerMessageSaved': 'Mensaje del cliente guardado',
  'cus.chat.internalNoteSaved': 'Nota interna guardada',
  'cus.chat.saveFailed': 'No se pudo guardar el mensaje.',
  'cus.chat.sent': 'Mensaje enviado al cliente',
  'cus.chat.sendFailed': 'No se pudo guardar o enviar el mensaje.',
  'cus.chat.modalTitle': 'Conversación - {name}',
  'cus.chat.dialogN': 'Diálogo {n} · {date}',
  'cus.chat.newConversation': 'Nueva conversación ({date})',
  'cus.chat.readyForQuote': 'Listo para presupuesto',
  'cus.chat.chipDialog': 'Diálogo con el cliente',
  'cus.chat.noMessages': 'No hay mensajes en esta vista.',
  'cus.chat.sumExVat': 'Suma sin IVA',
  'cus.chat.vat25': 'IVA (25 %)',
});
